var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NewPaymentsPayoneerEditAdmin',{attrs:{"NPP":_vm.NPP,"serverError":_vm.serverError},on:{"updatePayment":_vm.updatePayment,"pay":_vm.pay}})
}
var staticRenderFns = []

export { render, staticRenderFns }